import { StateType } from 'data/types'

import { ProductEligibility } from './types'

export const getEligibility = (state: StateType): ProductEligibility => state.eligibility.data
